export default __webpack_public_path__ + "static/media/molog-grey.1e031de1.png";